// extracted by css-extract-rspack-plugin
export default {"field":"FormField__field--XAWfB","label":"FormField__label--F0Lsu","note":"FormField__note--TcKjG"};